import { Controller } from "@hotwired/stimulus"
import { showToast } from "../helpers/toast"
import * as Turbo from "@hotwired/turbo"

const MAX_POLLS = 120
const POLL_INTERVAL = 3000

export default class extends Controller {
  static values = {
    url: String,
    action: String,
    buttonId: String
  }

  connect() {
    this.pollCount = 0
    this.timer = setInterval(() => this.poll(), POLL_INTERVAL)
    this.boundOnCompleted = () => this.handleExternalCompletion()
    document.addEventListener("ia-action:completed", this.boundOnCompleted)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("ia-action:completed", this.boundOnCompleted)
  }

  handleExternalCompletion() {
    clearInterval(this.timer)
    Turbo.visit(window.location.href, { action: "replace" })
  }

  async poll() {
    this.pollCount++

    if (this.pollCount > MAX_POLLS) {
      clearInterval(this.timer)
      showToast("Traitement trop long — rechargez la page.", "warning")
      return
    }

    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      const resp = await fetch(this.urlValue, {
        headers: { "Accept": "application/json", "X-CSRF-Token": csrf }
      })
      if (!resp.ok) return

      const data = await resp.json()
      const info = data[this.actionValue]
      if (!info) return

      if (info.status === "completed") {
        clearInterval(this.timer)
        if (info.message) sessionStorage.setItem("pendingToast", JSON.stringify({ message: info.message, type: "success" }))
        Turbo.visit(window.location.href, { action: "replace" })
      } else if (info.status === "failed") {
        clearInterval(this.timer)
        showToast(info.message || "Une erreur est survenue", "error")
      }
    } catch (err) {
      console.warn("[async-status] poll error:", err)
    }
  }
}
